



import '../../../../assets/css/screens/admin/dashboard/adminhome/Adminhome.css';
import AdminSidebar from '../../../../components/admin/dashboard/adminsidebar/AdminSidebar';
import AppContext from '../../../../context/AppContext';
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  Users, Wrench, CalendarCheck, DollarSign,
  TrendingUp, TrendingDown, Clock, ArrowRight,
  Eye, CheckCircle, XCircle, AlertCircle, MessageSquare
} from 'lucide-react';

const STATS = [
  {
    icon: Users, color: '#ffffff', bg: 'linear-gradient(135deg,#0491e1 0%,#0672b5 100%)',
    shadow: 'rgba(4,145,225,0.40)', value: '2,450', label: 'Total Customers', change: '+12%', up: true, path: '/admin-customers'
  },
  {
    icon: Wrench, color: '#ffffff', bg: 'linear-gradient(135deg,#0491e1 0%,#0672b5 100%)',
    shadow: 'rgba(4,145,225,0.40)', value: '150', label: 'Total Providers', change: '+8%', up: true, path: '/admin-providers'
  },
  {
    icon: CalendarCheck, color: '#ffffff', bg: 'linear-gradient(135deg,#0491e1 0%,#0672b5 100%)',
    shadow: 'rgba(4,145,225,0.40)', value: '1,284', label: 'Active Bookings', change: '+23%', up: true, path: '/admin-bookings'
  },
  {
    icon: DollarSign, color: '#ffffff', bg: 'linear-gradient(135deg,#0491e1 0%,#0672b5 100%)',
    shadow: 'rgba(4,145,225,0.40)', value: '$2M', label: 'Total Earnings', change: '+5%', up: true, path: '/admin-earnings'
  },
];



// const STATUS_STYLE = {
//   Active:    { color:'#fff', bg:'linear-gradient(135deg,#0491e1,#0672b5)', icon:<AlertCircle size={12}/> },
//   Completed: { color:'#fff', bg:'linear-gradient(135deg,#10b981,#059669)', icon:<CheckCircle size={12}/> },
//   Pending:   { color:'#fff', bg:'linear-gradient(135deg,#f59e0b,#d97706)', icon:<Clock size={12}/> },
//   Cancelled: { color:'#fff', bg:'linear-gradient(135deg,#ef4444,#dc2626)', icon:<XCircle size={12}/> },
// };

const useCount = (target, duration = 1400) => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    const num = parseFloat(target.replace(/[^0-9.]/g, '')) || 0;
    if (num === 0) return;
    const step = num / (duration / 16);
    let cur = 0;
    const timer = setInterval(() => {
      cur += step;
      if (cur >= num) { setVal(num); clearInterval(timer); }
      else setVal(cur);
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration]);
  if (target.includes('Rs')) return '$' + (val >= 1000000 ? (val / 1000000).toFixed(1) + 'M' : Math.round(val).toLocaleString());
  return Math.round(val).toLocaleString();
};

const StatCard = ({ stat, idx }) => {
  const navigate = useNavigate();
  const Icon = stat.icon;
  const display = useCount(stat.value);


  return (
    <div
      className="adb-stat"
      style={{ animationDelay: idx * 0.10 + 's', background: stat.bg, '--shadow': stat.shadow }}
      onClick={() => navigate(stat.path)}
    >
      {/* Decorative circle */}
      <div className="adb-stat__circle" />

      <div className="adb-stat__top">
        <div className="adb-stat__icon">
          <Icon size={24} />
        </div>
        <span className="adb-stat__change">
          {stat.up ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
          {stat.change}
        </span>
      </div>

      <div className="adb-stat__value">{display}</div>
      <div className="adb-stat__footer">
        <span className="adb-stat__label">{stat.label}</span>
        <ArrowRight size={14} className="adb-stat__arrow" />
      </div>
    </div>
  );
};

const Adminhome = () => {
  const { baseUrl, authToken } = useContext(AppContext);

  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const fetchDisputedJobs = () => {
    axios.get(`${baseUrl}/dissputed/jobs`, {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    })
      .then((res) => {
        console.log("API RESPONSE:", res.data);
        setJobs(res.data.jobs);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };


  useEffect(() => {
    fetchDisputedJobs();
  }, []);

  return (
    <div className="adb-page">

      {/* Heading */}
      <div className="adb-heading">
        <div>
          <h2 className="adb-heading__title">Dashboard</h2>
          <p className="adb-heading__sub">Welcome back, Admin 👋</p>
        </div>
        <div className="adb-heading__date">
          <Clock size={14} />
          {new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
        </div>
      </div>

      {/* Stats */}
      <div className="adb-stats">
        {STATS.map((s, i) => <StatCard key={s.label} stat={s} idx={i} />)}
      </div>

      {/* Recent Bookings */}
      <div className="adb-table-card">
        <div className="adb-table-card__header">
          <h5 className="adb-table-card__title">Disputed Jobs</h5>
          <button className="adb-view-all" onClick={() => navigate('/support-tickets')}>
            View All <ArrowRight size={14} />
          </button>
        </div>

        {/* Desktop table */}
        <div className="adb-table-wrap">
          <table className="adb-table">
            <thead>
              <tr>
                <th>ID</th><th>Customer</th><th>Provider</th>
                <th>Service</th><th>Job Title</th><th>Status</th>

                <th className="adb-table__right">Amount</th>
              </tr>
            </thead>
            <tbody>
              {jobs.length === 0 ? (
                <tr>
                  <td colSpan="7">No disputed jobs found</td>
                </tr>
              ) : (
                jobs.map((b, i) => {
                  return (
                    <tr key={b.id} className="adb-table__row">

                      {/* ID */}
                      <td>{b.id}</td>

                      {/* Customer */}
                      <td>
                        <strong>{b.whcustomer?.fullName}</strong>
                      </td>

                      {/* Provider */}
                      <td>
                        {b.whserviceprovider?.fullName || "Not Assigned"}
                      </td>

                      {/* Service (JOB TITLE REMOVE NAHI KARNA — but separate column use karo) */}
                      <td>{b.serviceType || "N/A"}</td>

                      <td>{b.jobTitle}</td>

                      {/* Status (ONLY STATUS HERE) */}
                      <td>
                        <span
                          className={`adb-badge ${b.status === 'raise_dispute' ? 'disputed' : ''
                            }`}
                        >
                          {b.status === 'raise_dispute' ? 'Disputed' : b.status}
                        </span>
                      </td>

                      {/* Amount */}
                      <td>
                        {b.budget}
                      </td>

                      {/* Action (CHAT BUTTON) */}


                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* Mobile cards */}
        {/* <div className="adb-mob-list">
          {BOOKINGS.map((b,i) => {
            const st = STATUS_STYLE[b.status] || STATUS_STYLE.Pending;
            return (
              <div key={b.id} className="adb-mob-card" style={{animationDelay:i*0.06+'s'}}
                onClick={()=>navigate(`/admin-booking/${b.id}`)}>
                <div className="adb-mob-card__top">
                  <span className="adb-table__id">{b.id}</span>
                  <span className="adb-badge" style={{color:st.color,background:st.bg}}>{st.icon} {b.status}</span>
                </div>
                <div className="adb-mob-card__customer">{b.customer}</div>
                <div className="adb-mob-card__meta">
                  <span className="adb-table__muted">{b.provider}</span>
                  <span className="adb-table__amount">{b.amount}</span>
                </div>
              </div>
            );
          })}
        </div> */}

      </div>
    </div>
  );
};

export default Adminhome;